import React, { useState } from "react";
import "../styles/NewsBarPage.css";

import news1 from "../assets/news/news1.jpg";
import news2 from "../assets/news/news2.jpg";
import news3 from "../assets/news/news3.jpg";
import news4 from "../assets/news/news4.jpg";
import news5 from "../assets/news/news5.jpg";
import news6 from "../assets/news/news6.jpg";
import news7 from "../assets/news/news7.jpg";
import news8 from "../assets/news/news8.jpg";
import news9 from "../assets/news/news9.jpg";
import news10 from "../assets/news/news10.jpg";

const newsData = [
  { 
    id: 1,
    image: news1, 
    title: "Board of Directors Structure Chart",
    category: "Corporate"
  },
  { 
    id: 2,
    image: news2, 
    title: "Board Meeting Moment",
    category: "Meeting"
  },
  { 
    id: 3,
    image: news3, 
    title: "Board in Session",
    category: "Meeting"
  },
  { 
    id: 4,
    image: news4, 
    title: "Dinner with the Board",
    category: "Event"
  },
  { 
    id: 5,
    image: news5, 
    title: "Founders Together",
    category: "Corporate"
  },
  { 
    id: 6,
    image: news6, 
    title: "Meeting with Libya PM Candidate",
    category: "Diplomatic"
  },
  { 
    id: 7,
    image: news7, 
    title: "Opening Meeting Moment",
    category: "Meeting"
  },
  { 
    id: 8,
    image: news8, 
    title: "President with Board Members",
    category: "Corporate"
  },
  { 
    id: 9,
    image: news9, 
    title: "Founding Iftar Gathering",
    category: "Event"
  },
  { 
    id: 10,
    image: news10, 
    title: "Istanbul Branch Opening",
    category: "Announcement"
  },
];

const NewsTicker = () => {
  const [hoveredItem, setHoveredItem] = useState(null);
  
  // Sonsuz kaydırma için 3 kopya (daha akıcı)
  const repeatedNews = [...newsData, ...newsData, ...newsData];

  return (
    <div className="news-ticker-simple">
      <div className="ticker-container-simple">
        <div className="ticker-gradient ticker-gradient--left"></div>
        <div className="ticker-gradient ticker-gradient--right"></div>
        
        <div className="ticker-track-simple">
          <div className="ticker-content-simple">
            {repeatedNews.map((item, index) => (
              <div 
                className={`ticker-item-simple ${hoveredItem === index ? 'ticker-item-simple--hover' : ''}`}
                key={`${item.id}-${index}`}
                onMouseEnter={() => setHoveredItem(index)}
                onMouseLeave={() => setHoveredItem(null)}
              >
                <div className="ticker-image-container-simple">
                  <img src={item.image} alt={item.title} loading="lazy" />
                  <span className="ticker-category-simple">{item.category}</span>
                </div>
                
                <div className="ticker-content-info-simple">
                  <h4 className="ticker-title-simple">{item.title}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsTicker;